import VeedaSoftware from './pages/Home'

function App() {
  return <VeedaSoftware />
}

export default App
